import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Soort } from '../dto/soort';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class SoortService extends CrudService<Soort> {

    constructor(injector: Injector) { super(Soort, injector); }

}
